import LayoutSearch from "../components/LayoutSearch";

import Jumbotron from "../components/find-agent/Jumbotron";
import Agents from "../components/find-agent/Agents";
import Container from "../components/find-agent/Container";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import BlogList from "../components/find-agent/BlogList";
import Areas from "../components/find-agent/Areas";

import React from "react";
import { NextSeo } from "next-seo";
import { getSeoFindAgent } from "../service/seo";
import axiosResiInstance from "../http/axiosResi";
import * as resiPromise from "../http/resiPromise";
import reportFailedRequest from "../service/error";
import { sendAgentView } from "../service/agent-view";
import { fetchGepIp } from "../service/cache";
import requestIp from "request-ip";

const AGENT_LIST_LIMIT = 12;

const fetchAgents = (cityId) => {
    return axiosResiInstance.get("/agents", {
        params: {
            location: cityId,
            format: "featured_only",
            limit: AGENT_LIST_LIMIT,
            offset: 0,
            sort: "-added_date",
        },
    });
};

const fetchBlogs = (category, limit) => {
    return axiosResiInstance.get("/blogs", {
        params: {
            category: category,
            page: "FIND_AGENT",
            limit: limit,
        },
    });
};

const FindAgent = (props) => {
    const { city, agents, blogs } = props;

    const SEO = getSeoFindAgent();

    return (
        <LayoutSearch>
            <NextSeo {...SEO} />
            <Jumbotron city={city} />

            {agents && (
                <Container
                    title={
                        <>
                            Notable Agents in <strong>{city.label}</strong>
                        </>
                    }
                    link={
                        <a href={`/real_estate_agents/${city.url}`}>
                            See all <ChevronRightIcon />
                        </a>
                    }
                >
                    <Agents agents={agents} />
                </Container>
            )}

            {blogs && (
                <Container
                    background={"white"}
                    title={
                        <>
                            <strong>Real Estate</strong> Tips & Articles
                        </>
                    }
                >
                    <BlogList blogs={blogs} />
                </Container>
            )}

            <Container
                title={
                    <>
                        Agents in <strong>Popular Areas</strong>
                    </>
                }
            >
                <Areas />
            </Container>
        </LayoutSearch>
    );
};

FindAgent.getInitialProps = async ({ req }) => {
    const ip = req ? requestIp.getClientIp(req) : null;

    const response = await resiPromise.allSettledReported(
        [fetchGepIp(ip), fetchBlogs(["TIPS_REAL_ESTATE_AGENTS"], 4)],
        "pages/find-agent.js",
        req
    );

    const city =
        response[0] && response[0].data && response[0].data.city
            ? response[0].data.city
            : null;
    const blogs =
        response[1] && response[1].data.data.length > 0
            ? response[1].data.data
            : null;

    let agents = null;

    // AGENTS
    if (city) {
        await fetchAgents(city.id)
            .then((response) => {
                if (response.data.data.length) {
                    agents = response.data.data;
                }
            })
            .then(() => {
                if (agents && agents.length) {
                    let agentIds = [];

                    agents.map((agent) => {
                        agentIds.push(agent.id);
                    });

                    if (agentIds.length) {
                        sendAgentView(agentIds, "FIND_AGENT_INDEX_FEATURED");
                    }
                }
            })
            .catch(async (e) => {
                reportFailedRequest(e, req, "pages/find-agent.js", {
                    location: city.id,
                    format: "featured_only",
                    limit: AGENT_LIST_LIMIT,
                    offset: 0,
                    sort: "-added_date",
                });
            });
    }

    return {
        city,
        agents,
        blogs,
    };
};

export default FindAgent;
